import React from "react";
import {View} from "@unibuddy/patron";
import {usePageTitle} from "ubcommunity-shared/src/Hooks/usePageTitle";
import {Landing} from "ubcommunity-shared/src/Auth/Landing/Landing";
import {useLocationQuery} from "ubcommunity-shared/src/Hooks/useLocationQuery";

import {SharedLandingV2} from "./SharedLandingV2";

export function LandingV2() {
    usePageTitle();

    const query = useLocationQuery();
    const source = query.get("source");
    const inviteId = query.get("inviteId");

    if (source && inviteId) {
        return (
            <View alignItems="center" justifyContent="center" height="100%">
                <SharedLandingV2 inviteId={inviteId} source={source} />
            </View>
        );
    }

    return <Landing />;
}
